import {ref} from 'vue'
import {DateRange} from '@/dateUtils/DateRange'
import {format} from 'date-fns'

const getTodayTermDate = (currentTerm: number) => {
    const today = new Date()
    const startMonth = currentTerm * 2 - 2
    const endMonth = currentTerm * 2
    return {startTerm: new Date(today.getFullYear(), startMonth, 1), endTerm: new Date(today.getFullYear(), endMonth, 0)}
}

const getMaxDateRange = () => {
    //Start at 1st January 2020, end at 31st December 2030
    return {
        start: new Date(2020, 0, 1),
        end: new Date(2040, 11, 31)
    }
}

const getSpecifiedTermDate = (currentTerm: number, year: number) => {
    const startMonth = currentTerm * 2 - 2
    const endMonth = currentTerm * 2
    return {startTerm: new Date(year, startMonth, 1), endTerm: new Date(year, endMonth, 0)}
}

const persistentRange = ref<DateRange>()

const serializeDateRange = (range: DateRange) => {
    return JSON.stringify({
        start: format(range.start, 'yyyy-MM-dd'),
        end: format(range.end, 'yyyy-MM-dd')
    })
}

const marshalDateRange = (sRange: string) => {
    const parsed = JSON.parse(sRange)
    return {
        start: new Date(parsed.start),
        end: new Date(parsed.end)
    }
}

const getPersistedRangeOr = (fallback: DateRange) => {
    try {
        const sRange = localStorage.getItem('persistedDateRange') || ''
        return marshalDateRange(sRange) || fallback
    } catch (e) {
        return fallback
    }
}

const updatePersistedRange = (newRange: DateRange) => {
    localStorage.setItem('persistedDateRange', serializeDateRange(newRange))
    persistentRange.value = newRange
}

export {getTodayTermDate, getSpecifiedTermDate, getPersistedRangeOr, getMaxDateRange, updatePersistedRange, persistentRange}